import { render } from "./JournesyContent.vue?vue&type=template&id=4cc135e0&ts=true"
import script from "./JournesyContent.vue?vue&type=script&lang=ts"
export * from "./JournesyContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__